import { render, staticRenderFns } from "./Ocpendiente.vue?vue&type=template&id=6d8965f4&scoped=true"
import script from "./Ocpendiente.vue?vue&type=script&lang=js"
export * from "./Ocpendiente.vue?vue&type=script&lang=js"
import style0 from "./Ocpendiente.vue?vue&type=style&index=0&id=6d8965f4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d8965f4",
  null
  
)

export default component.exports